import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import { Provider } from 'react-redux';
import { store } from '@app/store';

import { DashboardScreen } from '@app/screens/Dashboard';
const App = () =>
{
  return (
    <Provider store={store}>
      <Router>
        <Route path="/" exact component={DashboardScreen} />
      </Router>
    </Provider>
  )
}
export default App;